import React from "react";

const Users = () => {
  return (
    <div>
      <div>Users</div>
    </div>
  );
};

export default Users;
